<template>
  <div id="Schedule">
    <b-container fluid class="scheduleMain">
      <b-row>
        <b-col>
          <h2>2026 Schedule</h2>
          <div class="line"></div>
        </b-col>
      </b-row>
      <div class="legend">
        <div class="legend-icon home"></div>
        <!-- <strong>Exhibition Games</strong> -->
        <div class="legend-icon non-premier-legend"></div>
        <strong>Home Games</strong>
      </div>
      <div class="scheduleWrapper">
        <div class="schedule-item">
          <div class="calendar">
            <div class="calendar-month">
              <h3><span>March/April</span></h3>
            </div>
            <div class="calendar-row clearfix">
              <span class="calendar-day-head">Sun</span>
              <span class="calendar-day-head">Mon</span>
              <span class="calendar-day-head">Tue</span>
              <span class="calendar-day-head">Wed</span>
              <span class="calendar-day-head">Thu</span>
              <span class="calendar-day-head">Fri</span>
              <span class="calendar-day-head">Sat</span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day no-game">
                <div class="day-number">22</div>
                <p></p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">23</div>
                <p></p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">24</div>
                <p></p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">25</div>
                <p>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">26</div>
                <p>
                  PHI
                  <span>2:05</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">27</div>
                <p>

                </p>
              </span>
              <span class="calendar-day ">
                <div class="day-number">28</div>
                <p>
                  PHI
                  <span>3:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">29</div>
                <p>
                  PHI
                  <span>12:35</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">30</div>
                <p>
                  BAL
                  <span>5:35</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">31</div>
                <p>
                  BAL
                  <span>5:35</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">1</div>
                <p>
                  BAL
                  <span>11:35</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">2</div>
                <p>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">3</div>
                <p>
                  CIN
                  <span>3:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">4</div>
                <p>
                  CIN
                  <span>6:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">

              <span class="calendar-day home">
                <div class="day-number">5</div>
                <p>
                  CIN
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">6</div>
                <p>
                  SEA
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">7</div>
                <p>
                  SEA
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">8</div>
                <p>
                  SEA
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">9</div>
                <p></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">10</div>
                <p>
                  LAD
                  <span>9:10</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">11</div>
                <p>
                  LAD
                  <span>8:10</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">12</div>
                <p>
                  LAD
                  <span>3:10</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">13</div>
                <p>
                  ATH
                  <span>8:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">14</div>
                <p>
                  ATH
                  <span>8:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">15</div>
                <p>
                  ATH
                  <span>8:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">16</div>
                <p>
                  ATH
                  <span>2:05</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">17</div>
                <p>
                  SEA
                  <span>8:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">18</div>
                <p>
                  SEA
                  <span>6:15</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">19</div>
                <p>
                  SEA
                  <span>3:10</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">20</div>
                <p></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">21</div>
                <p>
                  PIT
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">22</div>
                <p>
                  PIT
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">23</div>
                <p>
                  PIT
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">24</div>
                <p>
                  ATH
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">25</div>
                <p>
                  ATH
                  <span>6:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">26</div>
                <p>
                  ATH
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">27</div>
                <p>
                  NYY
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">28</div>
                <p>
                  NYY
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">29</div>
                <p>
                  NYY
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">30</div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
            </div>
          </div>
        </div>
        <div class="schedule-item">
          <div class="calendar">
            <div class="calendar-month">
              <h3><span>May</span></h3>
            </div>
            <div class="calendar-row clearfix">
              <span class="calendar-day-head">Sun</span>
              <span class="calendar-day-head">Mon</span>
              <span class="calendar-day-head">Tue</span>
              <span class="calendar-day-head">Wed</span>
              <span class="calendar-day-head">Thu</span>
              <span class="calendar-day-head">Fri</span>
              <span class="calendar-day-head">Sat</span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">1</div>
                <p>
                  DET
                  <span>5:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">2</div>
                <p>
                  DET
                  <span>6:15</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">3</div>
                <p>
                  DET
                  <span>12:40</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">4</div>
                <p></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">5</div>
                <p>
                  NYY
                  <span>6:05</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">6</div>
                <p>
                  NYY
                  <span>6:05</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">7</div>
                <p>
                  NYY
                  <span>11:35</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">8</div>
                <p>
                  CHC
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">9</div>
                <p>
                  CHC
                  <span>6:05</span>
                </p>
              </span>

            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">10</div>
                <p>
                  CHC
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">11</div>
                <p>
                  AZ
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">12</div>
                <p>
                  AZ
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">13</div>
                <p>
                  AZ
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">14</div>
                <p></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">15</div>
                <p>
                  HOU
                  <span>TBD</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">16</div>
                <p>
                  HOU
                  <span>TBD</span>
                </p>
              </span>

            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">17</div>
                <p>
                  HOU
                  <span>TBD</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">18</div>
                <p>
                  COL
                  <span>7:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">19</div>
                <p>
                  COL
                  <span>7:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">20</div>
                <p>
                  COL
                  <span>2:10</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">21</div>
                <p></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">22</div>
                <p>
                  LAA
                  <span>8:38</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">23</div>
                <p>
                  LAA
                  <span>9:05</span>
                </p>
              </span>

            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">24</div>
                <p>
                  LAA
                  <span>3:07</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">25</div>
                <p>
                  HOU
                  <span>6:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">26</div>
                <p>
                  HOU
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">27</div>
                <p>
                  HOU
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">28</div>
                <p>
                  HOU
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">29</div>
                <p>
                  KC
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">30</div>
                <p>
                  KC
                  <span>3:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">31</div>
                <p>
                  KC
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
            </div>
          </div>
        </div>
        <div class="schedule-item">
          <div class="calendar">
            <div class="calendar-month">
              <h3><span>June</span></h3>
            </div>
            <div class="calendar-row clearfix">
              <span class="calendar-day-head">Sun</span>
              <span class="calendar-day-head">Mon</span>
              <span class="calendar-day-head">Tue</span>
              <span class="calendar-day-head">Wed</span>
              <span class="calendar-day-head">Thu</span>
              <span class="calendar-day-head">Fri</span>
              <span class="calendar-day-head">Sat</span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">1</div>
                <p>
                  STL
                  <span>6:45</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">2</div>
                <p>
                  STL
                  <span>6:45</span>
                </p>
              </span>
              <span class="calendar-day ">
                <div class="day-number">3</div>
                <p>
                  STL
                  <span>6:45</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">4</div>
              </span>
              <span class="calendar-day home">
                <div class="day-number">5</div>
                <p>
                  CLE
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">6</div>
                <p>
                  CLE
                  <span>6:35</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">7</div>
                <p>
                  CLE
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">8</div>
                <p></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">9</div>
                <p>
                  KC
                  <span>6:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">10</div>
                <p>KC
                  <span>6:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">11</div>
                <p>
                  KC
                  <span>1:10</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">12</div>
                <p>
                  BOS
                  <span>6:10</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">13</div>
                <p>
                  BOS
                  <span>3:10</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">14</div>
                <p>
                  BOS
                  <span>12:35</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">15</div>
                <p>
                  MIN
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">16</div>
                <p>
                  MIN
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">17</div>
                <p></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">18</div>
                <p>
                  MIN
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">19</div>
                <p>
                  SD
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">20</div>
                <p>
                  SD
                  <span>3:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">21</div>
                <p>
                  SD
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">22</div>
                <p>
                  MIA
                  <span>5:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">23</div>
                <p>
                  MIA
                  <span>5:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">24</div>
                <p>
                  MIA
                  <span>11:10</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">25</div>
                <p>
                  TOR
                  <span>6:07</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">26</div>
                <p>
                  TOR
                  <span>6:07</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">27</div>
                <p>
                  TOR
                  <span>2:07</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">28</div>
                <p>
                  TOR
                  <span>12:37</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">29</div>
                <p>
                  CLE
                  <span>TBD</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">30</div>
                <p>
                  CLE
                  <span>TBD</span>
                </p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
              <span class="calendar-day calendar-day-np">
                <div class="day-number"></div>
                <p></p>
              </span>
            </div>
          </div>
        </div>
        <div class="schedule-item">
          <div class="calendar">
            <div class="calendar-month">
              <h3><span>July</span></h3>
            </div>
            <div class="calendar-row clearfix">
              <span class="calendar-day-head">Sun</span>
              <span class="calendar-day-head">Mon</span>
              <span class="calendar-day-head">Tue</span>
              <span class="calendar-day-head">Wed</span>
              <span class="calendar-day-head">Thu</span>
              <span class="calendar-day-head">Fri</span>
              <span class="calendar-day-head">Sat</span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day calendar-day-np"> </span>
              <span class="calendar-day calendar-day-np"> </span>
              <span class="calendar-day calendar-day-np"> </span>
              <span class="calendar-day">
                <div class="day-number">1</div>
                <p>
                  CLE
                  <span>TBD</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">2</div>
                <p>
                  DET
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">3</div>
                <p></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">4</div>
                <p>
                  DET
                  <span>3:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">5</div>
                <p>
                  DET
                  <span>2:30</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">6</div>
                <p></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">7</div>
                <p>
                  LAA
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">8</div>
                <p>
                  LAA
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">9</div>
                <p>
                  LAA
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">10</div>
                <p>
                  HOU
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">11</div>
                <p>
                  HOU
                  <span>6:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">12</div>
                <p>
                  HOU
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">13</div>
                <p><span></span></p>
              </span>
              <!-- <span class="calendar-day no-game all-star"> -->
              <span class="calendar-day no-game">
                <div class="day-number">14</div>
                <!-- <p>ALL-STAR GAME<span></span></p> -->
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">15</div>
                <p><span></span></p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">16</div>
                <p><span></span></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">17</div>
                <p>
                  ATL
                  <span>6:15</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">18</div>
                <p>
                  ATL
                  <span>3:10</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">19</div>
                <p>
                  ATL
                  <span>12:35</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">20</div>
                <p>
                  CWS
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">21</div>
                <p>
                  CWS
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">22</div>
                <p>
                  CWS
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">23</div>
                <p></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">24</div>
                <p>
                  SEA
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">25</div>
                <p>
                  SEA
                  <span>6:15</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">26</div>
                <p>
                  SEA
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">27</div>
                <p>
                  SEA
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">28</div>
                <p>
                  TB
                  <span>5:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">29</div>
                <p>
                  TB
                  <span>5:40</span>
                </p>
              </span>
              <div class="calendar-day">
                <div class="day-number">30</div>
                <p>
                  TB
                  <span>11:10</span>
                </p>
              </div>
              <div class="calendar-day">
                <div class="day-number">31</div>
                <p>
                  HOU
                  <span>TBD</span>
                </p>
              </div>
              <div class="calendar-day-np"></div>
            </div>
          </div>
        </div>
        <div class="schedule-item">
          <div class="calendar">
            <div class="calendar-month">
              <h3><span>August</span></h3>
            </div>
            <div class="calendar-row clearfix">
              <span class="calendar-day-head">Sun</span>
              <span class="calendar-day-head">Mon</span>
              <span class="calendar-day-head">Tue</span>
              <span class="calendar-day-head">Wed</span>
              <span class="calendar-day-head">Thu</span>
              <span class="calendar-day-head">Fri</span>
              <span class="calendar-day-head">Sat</span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day-np"> </span>
              <span class="calendar-day-np"> </span>
              <span class="calendar-day-np"> </span>
              <span class="calendar-day-np"> </span>
              <span class="calendar-day-np"> </span>
              <span class="calendar-day-np"> </span>
              <span class="calendar-day">
                <div class="day-number">1</div>
                <p>
                  HOU
                  <span>TBD</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">2</div>
                <p>
                  HOU
                  <span>TBD</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">3</div>
                <p>
                  SF
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">4</div>
                <p>
                  SF
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">5</div>
                <p>
                  SF
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">6</div>
                <p></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">7</div>
                <p>
                  BAL
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">8</div>
                <p>
                  BAL
                  <span>6:15</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">9</div>
                <p>
                  BAL
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">10</div>
                <p>
                  LAA
                  <span>8:38</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">11</div>
                <p>
                  LAA
                  <span>8:38</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">12</div>
                <p>
                  LAA
                  <span>8:38</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">13</div>
                <p>
                  LAA
                  <span>9:07</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">14</div>
                <p>
                  ATH
                  <span>8:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">15</div>
                <p>
                  ATH
                  <span>8:40</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">16</div>
                <p>
                  ATH
                  <span>3:05</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">17</div>
                <p></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">18</div>
                <p>
                  WSH
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">19</div>
                <p>
                  WSH
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">20</div>
                <p>
                  WSH
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">21</div>
                <p>
                  LAA
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">22</div>
                <p>
                  LAA
                  <span>6:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">23</div>
                <p>
                  LAA
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">24</div>
                <p>
                  CWS
                  <span>6:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">25</div>
                <p>
                  CWS
                  <span>6:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">26</div>
                <p>
                  CWS
                  <span>6:40</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">27</div>
                <p></p>
              </span>
              <span class="calendar-day">
                <div class="day-number">28</div>
                <p>
                  MIL
                  <span>6:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">29</div>
                <p>
                  MIL
                  <span>6:15</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">30</div>
                <p>
                  MIL
                  <span>1:10</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">31</div>
                <p>
                  ATH
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day-np"> </span>
              <span class="calendar-day-np"> </span>
              <span class="calendar-day-np"> </span>
              <span class="calendar-day-np"> </span>
              <span class="calendar-day-np"> </span>
            </div>
          </div>
        </div>
        <div class="schedule-item">
          <div class="calendar">
            <div class="calendar-month">
              <h3><span>September/October</span></h3>
            </div>
            <div class="calendar-row clearfix">
              <span class="calendar-day-head">Sun</span>
              <span class="calendar-day-head">Mon</span>
              <span class="calendar-day-head">Tue</span>
              <span class="calendar-day-head">Wed</span>
              <span class="calendar-day-head">Thu</span>
              <span class="calendar-day-head">Fri</span>
              <span class="calendar-day-head">Sat</span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day-np"> </span>
              <span class="calendar-day-np"> </span>
              <span class="calendar-day home">
                <div class="day-number">1</div>
                <p>
                  ATH
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">2</div>
                <p>
                  ATH
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">3</div>
                <p>
                  TB
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">4</div>
                <p>
                  TB
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">5</div>
                <p>
                  TB
                  <span>6:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">6</div>
                <p>
                  TB
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">7</div>
              </span>
              <span class="calendar-day">
                <div class="day-number">8</div>
                <p>
                  SEA
                  <span>8:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">9</div>
                <p>
                  SEA
                  <span>8:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">10</div>
                <p>
                  SEA
                  <span>3:10</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">11</div>
                <p>
                  AZ
                  <span>8:40</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">12</div>
                <p>
                  AZ
                  <span>7:10</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">13</div>
                <p>
                  AZ
                  <span>3:10</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">14</div>
                <p></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">15</div>
                <p>
                  BOS
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">16</div>
                <p>
                  BOS
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">17</div>
                <p>
                  BOS
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">18</div>
                <p>
                  TOR
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">19</div>
                <p>
                  TOR
                  <span>6:05</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day home">
                <div class="day-number">20</div>
                <p>
                  TOR
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">21</div>
                <p></p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">22</div>
                <p>
                  NYM
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">23</div>
                <p>
                  NYM
                  <span>7:05</span>
                </p>
              </span>
              <span class="calendar-day home">
                <div class="day-number">24</div>
                <p>
                  NYM
                  <span>1:35</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">25</div>
                <p>
                  MIN
                  <span>7:10</span>
                </p>
              </span>
              <span class="calendar-day">
                <div class="day-number">26</div>
                <p>
                  MIN
                  <span>3:10</span>
                </p>
              </span>
            </div>
            <div class="calendar-row">
              <span class="calendar-day">
                <div class="day-number">27</div>
                <p>
                  MIN
                  <span>2:10</span>
                </p>
              </span>
              <span class="calendar-day no-game">
                <div class="day-number">28</div>
                <p></p>
              </span>
              <div class="calendar-day no-game">
                <div class="day-number">29</div>
              </div>
              <div class="calendar-day no-game">
                <div class="day-number">30</div>
              </div>
              <div class="calendar-day-np"></div>
              <div class="calendar-day-np"></div>
              <div class="calendar-day-np"></div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
    <b-container fluid class="small-text-container">
      <p class="small-text">Schedule subject to change.</p>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Schedule",
};
</script>

<style lang="scss" scoped>
#Schedule {
  padding: 50px 0;
  max-width: $xl;
  margin: 0 auto;

  .scheduleMain {
    padding: 0 7%;

    h2 {
      width: 143px;
      text-align: left;
      color: $dark-blue;
      font-size: 40px;
      line-height: 32px;
      text-transform: uppercase;
      font-family: "BertholdCondensed";
      font-weight: 700;
    }

    .scheduleWrapper {
      display: flex;
      flex-wrap: wrap;
      min-width: 100%;
      width: calc(100% + 20px);
      justify-content: center;
      margin-left: -10px;
      margin-top: 30px;
      background-color: #fff;
      padding: 1.5%;

      .calendar {
        width: 100%;
        height: auto;
        overflow: hidden;
        background: #fff;
        color: #002d72;
      }

      .calendar .calendar-month {
        h3 {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 15px;
          font-weight: 900;
          text-transform: uppercase;
        }

        h3 span {
          background: #fff;
          margin: 0 2px;
        }

        h3:after {
          background: $gold;
          height: 2px;
          flex: 1;
          content: "";
        }

        h3.right:before {
          background: none;
        }
      }

      .calendar .calendar-day-head {
        width: calc(100% / 7);
        display: block;
        float: left;
        text-align: center;
        font-size: 12px;
        text-transform: uppercase;
        font-family: "BertholdCondensed";
        font-weight: 700;
      }

      .calendar .calendar-day-np,
      .calendar .calendar-day {
        position: relative;
        width: calc(100% / 7.4);
        display: block;
        float: left;
        height: 50px;
        background: white;
        color: #000000;
        border: 1px solid #002d72;
        border-radius: 5px;
        margin: 1px;
        -webkit-transition: all 1s ease;
        -moz-transition: all 1s ease;
        -ms-transition: all 1s ease;
        transition: all 1s ease;

        &.exhibition,
        &.home {
          background: #C22032;
          border-color: #C22032;
          color: #fff;

          .day-number {
            color: #fff;
          }

          p {
            color: #fff;

            span {
              color: #fff;
            }
          }
        }

        &:not(.home) {
          background: $grey;
          border-color: $grey;
          
          p {
            opacity: 0;
          
          }
        }






        &.no-game {
          background: $grey;
          border-color: $grey;

          &.all-star {
            p {
              font-size: 11px;
            }
          }
        }

        &.waitlist {
          &:after {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            height: 75%;
            width: 75%;
            background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' preserveAspectRatio='none' viewBox='0 0 100 100'><path d='M 4 0 L 4 0 L 0 0 L 0 4 L 96 100 L 100 100 L 100 96' fill='rgb(37,96,163)' /><path d='M 96 0 L 96 0 L 100 0 L 100 4 L 4 100 L 0 100 L 0 96' fill='rgb(37,96,163)' /></svg>");
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 100% 100%, auto;
            z-index: 98;
          }
        }
      }

      .calendar .calendar-row {
        position: relative;
        overflow: hidden;

        .calendar-day-np {
          border: none;
          background-color: none;
        }

        // .waitlist {
        //   position: absolute;
        //   height: 100%;
        //   width: 100%;
        //   background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' preserveAspectRatio='none' viewBox='0 0 100 100'><path d='M 4 0 L 4 0 L 0 0 L 0 4 L 96 100 L 100 100 L 100 96' fill='rgb(37,96,163)' /><path d='M 96 0 L 96 0 L 100 0 L 100 4 L 4 100 L 0 100 L 0 96' fill='rgb(37,96,163)' /></svg>");
        //   background-repeat: no-repeat;
        //   background-position: center center;
        //   background-size: 100% 100%, auto;
        //   z-index: 98;
        // }

        #allstarText {
          p {
            font-size: 10px;
          }
        }
      }

      .calendar .calendar-day.small {
        height: 25px;

        &.abs-left {
          position: absolute;
          left: 0;
          top: 25px;
        }

        &.abs-left2 {
          position: absolute;
          top: 25px;
          left: calc(100% / 7);
          width: calc(100% / 7);
        }

        &.abs-left3 {
          position: absolute;
          top: 25px;
          left: calc(100% / 7);
          width: calc(100% / 7);
          margin-left: calc(100% / 7);
        }

        &.abs-left4 {
          position: absolute;
          top: 25px;
          left: calc(100% / 7);
          width: calc(100% / 7);
          margin-left: calc((100% / 7) + 14.2857143%);
        }

        &.abs-left5 {
          position: absolute;
          top: 25px;
          left: calc(100% / 7);
          width: calc(100% / 7);
          margin-left: calc((100% / 7) + 28.5714286%);
        }

        p {
          padding: 5px 0;
          font-size: 12px;
          line-height: 12px;
          margin: 0;
          margin-left: 5px;

          span {
            display: block;
            margin-top: -4px;
            font-size: 8px;
          }
        }
      }

      .calendar .calendar-day .day-number {
        color: #002d72;
        position: absolute;
        font-size: 9px;
        top: 2px;
        left: 2px;
        font-family: "BertholdCondensed";
        font-weight: 700;
      }

      .calendar .calendar-day p {
        margin: 0;
        padding: 15px 0 20px;
        font-size: 16px;
        display: block;
        text-align: center;
        line-height: 1;
        color: #002d72;
        font-family: "BertholdCondensed";
        font-weight: 700;

        span {
          display: block;
          font-size: 12px;
          margin-top: 0px;
          color: #00285e;

          &.double {
            font-size: 6px;
            text-transform: uppercase;
          }
        }
      }

      .calendar .calendar-day.active {
        background: #002d62;

        .day-number,
        p {
          color: #fff;

          span {
            color: #fff;
          }
        }
      }

      .calendar .calendar-day.active .day-number,
      .calendar .calendar-day.active p {
        color: white;
      }

      .schedule-item {
        width: calc(33.33% - 21px);
        margin: 10px;

        @media only screen and (max-width: $lg) {
          width: calc(50% - 21px);
        }

        @media only screen and (max-width: $md) {
          width: calc(100% - 21px);
        }
      }
    }

    .legend {
      font-family: "BertholdCondensed";
      font-weight: 700;
      font-size: 15px;
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      text-transform: uppercase;

      @media only screen and (max-width: $sm) {
        flex-wrap: wrap;
        justify-content: left;
        gap: 2px;
      }

      .legend-icon {
        height: 14px;
        transform: rotate(45deg);
        width: 14px;
        margin: 4px 7px 0 0;

        @media only screen and (max-width: $sm) {}
      }

      // .home {
      //   background-color: $calendar-blue;
      // }
      .non-premier-legend {
        background-color: $calendar-red;
      }

      .premier-legend {
        background-color: $gold;
      }

      strong {
        font-size: 15px;
        color: #000;
        letter-spacing: 0;
        line-height: 24px;
        margin-right: 20px;
        font-weight: 800;

        @media only screen and (max-width: $sm) {
          width: 90%;
          text-align: left;
          margin: 0;
        }
      }

      span {
        font-size: 16px;
        color: #000;
        letter-spacing: 0;
        line-height: 24px;
      }
    }
  }

  .small-text-container {
    padding: 0 7%;
    margin: 7px 0 0 0;

    .small-text {
      text-align: right;
      margin: 0;
      font-size: 10px;
      color: #6b6b6b;
    }
  }
}
</style>
